import Account from './Account'

export default Account



// WEBPACK FOOTER //
// ./src/components/Users/Account/index.js